<!-- =========================================================================================
  File Name: Useridebar.vue
  Description: Update user - Sidebar component
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{$t("UPDATE_USER")}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">

        <!-- ID -->
        <vs-input :label="$t('USER_ID')" disabled v-model="user.userId" class="mt-5 w-full" name="id" v-validate="{ required: true }" icon-pack="feather" icon="icon-user" icon-no-border />
        <span class="text-danger text-sm" v-show="errors.has('id')">{{ errors.first('id') }}</span>

          <!-- NEW PASSWORD 
        <vs-input :label="$t('NEW_PASSWORD')" type="password" v-model="dataPassword" class="mt-5 w-full" name="password" ref="password" v-validate="{ min:8, max:20, regex:/(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/}" icon-pack="feather" icon="icon-lock" icon-no-border/>
        <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span> -->

        <!-- CONFIRM NEW PASSWORD 
        <vs-input :label="$t('CONFIRM_NEW_PASSWORD')"  type="password" v-model="dataConfirmPassword" class="mt-5 w-full" name="confirmPassword" v-validate="{ required: this.isRequiredForUpdate, min:8, max:20, confirmed:'password' }" icon-pack="feather" icon="icon-lock" icon-no-border/>
        <span class="text-danger text-sm" v-show="errors.has('confirmPassword')">{{ errors.first('confirmPassword') }}</span> --> 

        <!-- STATUS -->
        <div class="mt-5"  v-if="user.userStatus !=='4'">
          <label class="vs-select--label">{{$t('USER_STATUS')}}</label>
          <v-select :options="userStatus" label="text" name="userStatus" :get-option-label="getLabel" v-model="user.userStatus" :reduce="option => option.value" v-validate="{ required: true }" :clearable="false" :searchable="false" >
              <template v-slot:option="option">
                {{ $t(option.text) }}
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('userStatus')">{{ errors.first('userStatus') }}</span>
        </div>

        <!-- SUBSCRIPTION_YN -->
        <div class="mt-5"  v-if="user.userStatus !=='4'">
          <label class="vs-select--label">{{$t('SUBSCRIPTION_YN')}}</label>
          <v-select :options="subscriptionYN" label="text" name="subscriptionYN" :get-option-label="getLabel" v-model="user.subscriberYn" :reduce="option => option.value" v-validate="{ required: true }" :clearable="false" :searchable="false"  @input="changeSubscription($event)">
              <template v-slot:option="option">
                {{ $t(option.text) }}
            </template>
          </v-select>
          <span class="text-danger text-sm" v-if="this.count%2 !== 0"> {{$t('SUBSCRIPTION_CHANGE')}}  </span>
          <span class="text-danger text-sm" v-show="errors.has('subscriptionYN')">{{ errors.first('subscriptionYN') }}</span>
        </div>

        <!-- DISABLED STATUS
         <div class="mt-5" v-if="user.userStatus === '4'">
          <label class="vs-select--label">{{$t('USER_STATUS')}}</label>
          <v-select :options="disabledUserStatus" label="text" name="userStatus" :get-option-label="getLabel" v-model="user.userStatus" :reduce="option => option.value" v-validate="{ required: true }" :disabled="true" :clearable="false" :searchable="false" >
              <template v-slot:option="option">
                {{ $t(option.text) }}
            </template>
          </v-select>
        </div> -->

          <!-- BLOCKED REASON -->
          <div class="mt-5"  v-if="user.userStatus == '3'">
          <label class="vs-select--label">{{$t('BLOCKED_REASON')}}</label>
          <v-select :options="blockedReason" label="text" name="blockedReason" :get-option-label="getLabel" v-model="user.blockedReason" :reduce="option => option.value" v-validate="{ required: true }" :clearable="false" :searchable="false" >
              <template v-slot:option="option">
                {{ $t(option.text) }}
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('blockedReason')">{{ errors.first('blockedReason') }}</span>
        </div>

        <!-- EMAIL -->
        <vs-input  :label="$t('EMAIL')" v-model="user.email" class="mt-5 w-full" name="email" v-validate="{ max:50, required: true, email:true }" maxlength="51" icon-pack="feather" icon="icon-mail" icon-no-border  />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <vs-divider/>    

        <div class="mt-6">
          <vs-button class="w-full"  color="warning" @click="openConfirm('Reset')">{{$t('USER_RESET')}}</vs-button>
           <span class="text-danger text-sm font-bold">{{this.$t('USER_RESET_BUTTON_MESSAGE')}}</span>
        </div>
      </div>
    
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-5" @click="checkSubmit" :disabled="!isFormValid">{{$t('SUBMIT')}}</vs-button>
      <vs-button class="mr-5" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('CLOSE')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      this.initValues()
      let user  = JSON.parse(JSON.stringify(this.data.user))
      this.user = user
      this.count = 0
      this.$validator.reset()
    },
    dataPassword(val){
      if (Object.entries(this.data).length !== 0 && val !== '') {
        this.isRequiredForUpdate = true
      } else {
        this.isRequiredForUpdate = false
      }
    },
  },
  data() {
    return {

      user:{
        uuid:"",
        userId:"",
        name:"",
        email:"",
        userStatus:"",
        blockedReason: "",
        subscriberYn: ""
      },

      dataPassword: "",
      dataConfirmPassword: "",

      isRequiredForUpdate: false,
      isRequiredForStatus : false,
 
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },

      disabledUserStatus: [
          { text: 'DISABLED', value: "4" },
      ],
      count: 0,
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
        return !this.errors.any()
    },
    userStatus(){
      return this.$store.state.dataUser.userStatus
    },
    blockedReason(){
      return this.$store.state.dataUser.blockedReason
    },
    subscriptionYN(){
      return this.$store.state.dataUser.subscriptionYn
    }
  },
  methods: {
    changeSubscription(event){
      this.count++;
    },
    initValues() {
      if (this.data.id) return
      this.user.uuid = ""
      this.user.userId = ""
      this.user.name = ""
      this.dataPassword = ""
      this.dataConfirmPassword = ""
      this.user.email = ""
      this.user.userStatus = "ACTIVE"
      this.user.blockedReason = ""
      this.user.subscriberYn = ""
      this.count=0
    },
    checkSubmit(){
      this.$validator.validateAll().then(result => {
        if (result) {
           this.openConfirm('Submit')
        }
      })
      .catch((error)=>{
          this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    submitData() {
        this.$vs.loading()

        const obj = {
            uuid: this.user.uuid,
            userId : this.user.userId,
            name : this.user.name,
            email : this.user.email,
            userStatus : this.user.userStatus,
            blockedReason : this.user.blockedReason,
            subscriberYn : this.user.subscriberYn
        }
       
        this.$store.dispatch("dataUser/updateUser", obj)
        .then(() => {
          this.formClear(this.$t('UPDATE_USER_SUCCESS'))
        })
        .catch(error => { 
          this.errorAlert(this.$t("ERROR"), error.message)
          this.$vs.loading.close()
        })
        
    },
    formClear(submitMessage){
        this.$vs.loading.close()
        this.$emit('closeSidebar')
        this.initValues() 
        this.successAlert(this.$t("SUCCESS"),submitMessage)
        this.$parent.$refs.userTable.getData()
    },
    resetUser(){
      this.$vs.loading()
      this.$store.dispatch("dataUser/resetUser", this.user.uuid)
        .then(() => {
          this.formClear(this.$t('RESET_USER_SUCCESS'))
        })
        .catch(error => { 
          this.errorAlert(this.$t("ERROR"), error.message)
          this.$vs.loading.close()
        })
    },
    openConfirm(action) {
      
      let textMessage = ""
      let acceptAction =""

      if (action === "Submit" && (this.count%2 === 0) ) {
        textMessage = this.$t('SUBMIT_CONFIRM_MESSAGE')
        acceptAction = this.submitData
      } else if (action === "Submit" && (this.count%2 !== 0) ) {
        textMessage = this.$t('SUBMIT_SUBSCRIPTION_CHANGE_CONFIRM_MESSAGE')
        acceptAction = this.submitData
      } else if (action === "Reset") {
        textMessage = this.$t('RESET_CONFIRM_MESSAGE')
        acceptAction = this.resetUser
      }

      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('CONFIRM'),
          text: textMessage,
          accept: acceptAction,
          acceptText: this.$t('CONFIRM'),
          cancelText: this.$t('CANCEL')
      })
    },
    getLabel(option) {
      return this.$t([option.text])
    },
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52004;
  }

  ::v-deep .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.admin-id-button{
    width:100%; 
    cursor: default;
}
</style>
